
// Text Magnifier implementation that displays text under cursor in a large lens.
export default class Magnifier {
    constructor() {
      this.active = false;
      this.glass = null;
      this.glassText = null;
      this.handler = this.handleMouseMove.bind(this);
    }
  
    enable() {
      if (this.active) return;
      this.active = true;
  
      const glass = document.createElement('div');
      glass.className = 'a11y-magnifier-glass';
      const content = document.createElement('div');
      content.className = 'a11y-magnifier-content';
      glass.appendChild(content);
      document.body.appendChild(glass);
      this.glass = glass;
      this.glassText = content;
  
      document.addEventListener('mousemove', this.handler);
    }
  
    disable() {
      if (!this.active) return;
      document.removeEventListener('mousemove', this.handler);
      this.glass?.remove();
      this.glass = null;
      this.active = false;
    }
  
    handleMouseMove(e) {
      if (!this.glass) return;
      const x = e.clientX;
      const y = e.clientY;
  
      // Hide if over sidebar
      if (e.target.closest('.a11y-sidebar')) {
        this.glass.style.display = 'none';
        return;
      }
      this.glass.style.display = 'flex';
  
      const offset = 20;
      const margin = 12;
      const glassWidth = this.glass.offsetWidth;
      const glassHeight = this.glass.offsetHeight;
      let left = x - glassWidth / 2;
      let top = y - glassHeight - offset;

      if (top < margin) {
        top = y + offset;
      }

      const maxTop = window.innerHeight - glassHeight - margin;
      if (top > maxTop) {
        top = maxTop;
      }

      if (left < margin) {
        left = margin;
      }

      const maxLeft = window.innerWidth - glassWidth - margin;
      if (left > maxLeft) {
        left = maxLeft;
      }

      this.glass.style.left = `${left}px`;
      this.glass.style.top = `${top}px`;
  
      // Get content
      const target = document.elementFromPoint(x, y);
      if (!target) return;
      
      const text = target.innerText || target.textContent;
      if (text && text.trim().length > 0) {
        const cleanText = text.trim();
        const maxLength = 1000;
        this.glassText.textContent = cleanText.length > maxLength
          ? `${cleanText.substring(0, maxLength)}...`
          : cleanText;
      }
    }
}
